import axios from 'axios';

const API_BASE = '/api'; // Replace with actual server IP

export async function signupUser(name, email, password) {
  const res = await axios.post(`${API_BASE}/signup`, { name, email, password });
  return res.data;
}

export async function loginUser(email, password) {
  const res = await axios.post(`${API_BASE}/login`, { email, password });
  return res.data;
}